import { render } from "./PaymentSuccessFailedForm.vue?vue&type=template&id=1cf5add7&lang=pug"
import script from "./PaymentSuccessFailedForm.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessFailedForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__